// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./insa-css/insa-clients/Kestrel/insa-kendo-css/kendo.custom.css
// module id = 1860
// module chunks = 2